module.exports = __webpack_public_path__ + "img/campaign-headline.1184673.svg";